// extracted by mini-css-extract-plugin
export default {"container":"Scale_container__MXFUj","text":"Scale_text__ILjI4","input":"Scale_input__zwd8O","icon":"Scale_icon__5Wr6m"};